import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import ComparisonSection from "./components/ComparisonSection";
import AboutSection from "./components/AboutSection";
import ArticleCardsSection from "./components/ArticleCardsSection";
import TestimonialSection from "./components/TestimonialSection";
import SafetySection from "./components/SafetySection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://usfansspreadsheet.icu";

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "USFansSpreadsheet Polska",
            url: `${SITE_URL}/`,
            description: "Największy przewodnik i porównanie USFansSpreadsheet w Polsce. Ranking, recenzje i aktualne informacje 2026.",
            inLanguage: "pl",
            publisher: {
              "@type": "Organization",
              name: "USFansSpreadsheet Polska",
              url: `${SITE_URL}/`,
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "USFansSpreadsheet Polska",
            url: `${SITE_URL}/`,
            description: "Największy przewodnik i porównanie USFansSpreadsheet w Polsce. Ranking, recenzje i aktualne informacje 2026.",
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Strona Główna",
                item: `${SITE_URL}/`,
              },
            ],
          }),
        }}
      />

      <div className="min-h-screen flex flex-col">
        <Header />

        <main>
          <HeroSection />
          <CategorySection />
          <ComparisonSection />
          <AboutSection />
          <ArticleCardsSection />
          <TestimonialSection />
          <SafetySection />
          <FAQSection />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
}